// Shared greys for the Nova Studio shell. These aren't in the design system's token set yet, so
// they're centralised here rather than repeated as inline hexes across the catalogue, header, shell
// and version-history components. Replace with `theme.sys.*` tokens once equivalents exist.
export const NovaStudioColor = {
	// Hairline borders separating the catalogue panel, header and version rows.
	border: '#e6e8f0',
	// Secondary/label text (category names, tab hints, muted metadata).
	textMuted: '#6b7280',
	// Background of the per-category agent-count badge.
	badgeBackground: '#eef0f5',
	// Agent row label — slightly darker when the row is the selected agent.
	agentRowText: '#33334d',
	agentRowTextSelected: '#1a1a2b',
	// Keyboard-focus ring for the hand-rolled buttons (collapsible bar, variable rows) whose
	// `all: unset` strips the default outline. A high-contrast blue so it reads as a focus cue.
	focusRing: '#0b63ce',
} as const;
